import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import PendingIcon from '@mui/icons-material/Pending';
import CancelIcon from '@mui/icons-material/Cancel';
import DownloadIcon from '@mui/icons-material/Download';
import SharePointService from '../services/sharepoint.service';

export function UserProjects() {
    const [working, setWorking] = useState(false);
    const [files, setFiles] = useState([]);

    const handleWorking = (e) => { setWorking(e) };
    
    const handleFiles = (e) => {
        if (typeof e === 'object' && e !== null) {
            setFiles(Object.entries(e));
        } else {
            setFiles([]);
        }
    };

    const GetSPFiles = async () => {
        handleWorking(true);      
    
        try {
            let allFiles = await SharePointService.getUserDocuments();
            if (allFiles && allFiles.status !== 401) {
                handleFiles(allFiles.data);
            } else {
                handleFiles([]); // Fallback, wenn die Antwort nicht den Erwartungen entspricht
            }
        } catch (error) {
            console.error('Error fetching files:', error);
            handleFiles([]); // Fallback bei Fehler
        } finally {
            handleWorking(false);
        }
    };

    useEffect(() => {
        GetSPFiles();
    }, []);

    const content = (
        <>
            {Array.isArray(files) && files.length > 0 ? (
                files.map(([mapTitle, project], index) => (
                    <Accordion key={index}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel-content-${index}`} id={`panel-header-${index}`}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" mr={5}>
                                <Box flexGrow={1} textAlign={"left"}>
                                    {mapTitle}
                                </Box>
                                <Box display="flex" alignItems="center">
                                    {project.missingDocs?.length === 0 ? (
                                        <>Alle Dokumente vorhanden <CheckCircleIcon style={{ color: 'green', marginLeft: 5 }} /></>
                                    ) : (
                                        <>
                                            {project.missingDocs?.length || 0} <WarningIcon style={{ color: 'coral', marginLeft: 5 }} />
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            {project.missingDocs && project.missingDocs.length > 0 ? (
                                <Box textAlign={'left'} pb={3}>
                                    <Typography variant='h6'>Fehlende Dokumente:</Typography>
                                    {project.missingDocs.map((doc, index) => (
                                        <li key={index}>{doc}</li>
                                    ))}
                                </Box>
                            ) : null}
    
                            <Box pt={0} mb={5} textAlign={'left'}>
                                <Typography variant='h6'>Alle Dokumente zu diesem Projekt:</Typography>
                                {Array.isArray(project.files) && project.files.length > 0 ? (
                                    <Table sx={{ minWidth: 150 }} size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left" sx={{ fontWeight: "bold" }}>Dateiname</TableCell>
                                                <TableCell align="left" sx={{ fontWeight: "bold" }}>Art</TableCell>
                                                <TableCell align="right" sx={{ fontWeight: "bold" }}>Prüfung</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {project.files.map((file, fileIndex) => (
                                                <TableRow key={fileIndex}>
                                                    <TableCell sx={{ cursor: "pointer" }}>{file.name}</TableCell>
                                                    <TableCell sx={{ cursor: "pointer" }}>{file.Art}</TableCell>
                                                    <TableCell align="right">
                                                        {file.Geprueft === "Ja" ? (
                                                            <CheckCircleIcon style={{ color: 'green', marginLeft: 5 }} />
                                                        ) : file.Geprueft === "Nein" ? (
                                                            <PendingIcon style={{ color: 'coral', marginLeft: 5 }} />
                                                        ) : file.Geprueft === "Abgelehnt" ? (
                                                            <CancelIcon style={{ color: 'red', marginLeft: 5 }} />
                                                        ) : null}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                ) : (
                                    <Typography>Keine Dateien vorhanden</Typography>
                                )}
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                ))
            ) : (
                <Typography variant="h5" textAlign="center" my={5}>Ihnen wurden noch keine Projekte zugewiesen</Typography>
            )}
        </>
    );

    return (
        <Box sx={{ width: '100%' }}>
            {working ? (
                <Box py={10}>
                    <CircularProgress />
                </Box>
            ) : (
                content
            )}
        </Box>
    );
}
